module.exports = function ($filtersWrapper) {
    $filtersWrapper.find('.search-rendering__filter--expandable').each(function() {
        $expandableFilter = $(this);
        $filterHeightWrapper = $expandableFilter.find('.search-rendering__filters-height-wrapper').first();
        $toggle = $expandableFilter.find('.search-rendering__filter-toggle').first();
        $filterCheckboxesAndToggles = $filterHeightWrapper.children('.search-rendering__filters').children('.search-rendering__filter').children('.search-rendering__filter-checkbox-wrapper').children('.search-rendering__filter-checkbox, .search-rendering__filter-toggle');

        if ($expandableFilter.hasClass('search-rendering__filter--expanded')) {
            $filterHeightWrapper.removeAttr('aria-hidden');
            $toggle.attr('aria-expanded', 'true');
            $filterCheckboxesAndToggles.attr('tabindex', '');
        }
        else {
            $filterHeightWrapper.attr('aria-hidden', 'true');
            $toggle.attr('aria-expanded', 'false');
            $filterCheckboxesAndToggles.attr('tabindex', '-1');
        }        
    });
};